import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import MainMenu from 'common/navigation/containers/main-menu-container';
import Wrapper from 'common/navigation/wrapper';
import Home from '../component/home';
import {
  getKpisForLandingZone,
  getCampaignsForLandingZone,
} from './landing-zone/landing-zone-actions';

const mapStateToProps = state => ({
  userName: state.user.fullname,
  kpis: state.landingZone.kpisLandingZone,
  campaigns: state.landingZone.campaignsLandingZone,
});

const mapDispatchToProps = {
  getKpisForLandingZone,
  getCampaignsForLandingZone,
};

const HomeContainer = ({ intl, ...rest }) =>
  <Wrapper title={intl.formatMessage({ id: 'common.titles.HOME' })}>
    <MainMenu type='home' />
    <Home {...rest} />
  </Wrapper>;

HomeContainer.propTypes = {
  userName: PropTypes.string.isRequired,
  intl: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(HomeContainer));
